import type { AuthFitnessCenterDO, AuthStaffDO } from "@/types/auth";

const AUTH_SNAPSHOT_KEY = "portal-auth-snapshot";

export interface PortalAuthSnapshot {
  user: AuthStaffDO;
  activeGym: AuthFitnessCenterDO;
}

export const getPortalAuthSnapshot = (): PortalAuthSnapshot | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const rawSnapshot = window.localStorage.getItem(AUTH_SNAPSHOT_KEY);
  if (!rawSnapshot) {
    return null;
  }

  try {
    return JSON.parse(rawSnapshot) as PortalAuthSnapshot;
  } catch (error) {
    console.error("Failed to parse portal auth snapshot:", error);
    window.localStorage.removeItem(AUTH_SNAPSHOT_KEY);
    return null;
  }
};

export const setPortalAuthSnapshot = (snapshot: PortalAuthSnapshot) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(AUTH_SNAPSHOT_KEY, JSON.stringify(snapshot));
};

export const clearPortalAuthSnapshot = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(AUTH_SNAPSHOT_KEY);
};
